import { type ITaskCount } from 'src/graphql/schema';
import { CRITICALITY_CONFIG, getWorstCriticality } from 'src/shared/mappings/criticality';
import { cn } from 'src/lib/utils';

type Props = {
  taskCounts: Pick<ITaskCount, 'criticality' | 'count'>[];
};

const UnreadTasksIndicator = ({ taskCounts }: Props) => {
  const worstCriticality = getWorstCriticality(taskCounts);

  if (!worstCriticality) return null;

  return (
    <span
      role="img"
      aria-label={`Unread ${worstCriticality}-criticality tasks`}
      data-criticality={worstCriticality}
      className={cn('ml-auto size-2 shrink-0 rounded-full', CRITICALITY_CONFIG[worstCriticality].dotClassName)}
    />
  );
};

export default UnreadTasksIndicator;
